export default __webpack_public_path__ + "static/favicon-3b2f04807f1abf1bd825843e1c2ca7a2.png";